import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import './Head.css';
import { useLocation } from "react-router-dom";
// import Calender from "../calender/Calender";

function Header({ searchQuery, setSearchQuery, handleSearch, activeComponent, setSelectedMonth, setSelectedYear, selectedYear1, setSelectedYear1, selectedMonth1, setSelectedMonth1 }) {
  const [date, setDate] = useState(new Date());
  const [date1, setDate1] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);

  const formattedDate = date.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });
  const formattedDate1 = date1.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  // When user selects a date
  const handleDateChange = (value) => {
    setDate(value);
    setSelectedMonth(value.getMonth());
    setSelectedYear(value.getFullYear());
    setShowCalendar(false);
  };
  const handleDateChange1 = (value) => {
    setDate1(value);
    setSelectedMonth1(value.getMonth());
    setSelectedYear1(value.getFullYear());
    setShowCalendar(false);
  };
 
  // setShowCalendar(prev => !prev);

  const location = useLocation();
  const isCalendarRoute = location.pathname.includes("calendar");

  return (
    <>
      <div className="d-flex align-items-center header-container">
        <div className="calendar-section">
          {isCalendarRoute && (

            <div className="d-flex justify-content-baseline" onClick={() => setShowCalendar(!showCalendar)}>
              {activeComponent === "reservation" ?

              <h5 className="header-date m-0 ps-md-3 ps-0" style={{ paddingTop: "2px", paddingRight: "3px" }}>
                {formattedDate}
              </h5> :
              <h5 className="header-date m-0 ps-md-3 ps-0" style={{ paddingTop: "2px", paddingRight: "3px" }}>
                {formattedDate1}
              </h5> 

              }       

            </div>
          )}

          {showCalendar && (
            <div className={`calendar-dropdown shadow-lg ${showCalendar ? "show" : ""}`}>

              {activeComponent === "reservation" ?

                <Calendar
                  onChange={handleDateChange}
                  value={date}
                  view="year"
                  maxDetail="year"
                  minDetail="decade"
                /> :

                <Calendar
                  onChange={handleDateChange1}
                  value={date1}
                  view="year"
                  maxDetail="year"
                  minDetail="decade"
                />


              }
            </div>
          )}

        </div>
      </div>


    </>
  );
}

export default Header;
